import { render, staticRenderFns } from "./ConsultantLogin.vue?vue&type=template&id=125424d4"
import script from "./ConsultantLogin.vue?vue&type=script&lang=js"
export * from "./ConsultantLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ConsultantLogin.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports